import '../styles/DataPolicy.css';

const PrivacyPolicy = () => {
  const currentDate = new Date().toLocaleDateString('es-CL', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <div style={{ backgroundColor: 'white', display: 'flex', justifyContent: 'center' }}>
      <div style={{
        backgroundColor: 'white', display: 'flex', flexDirection: 'column', width: '80%', paddingBottom: '15%',
      }}
      >
        <h2>
          Política de Privacidad de MaipoSalud App
        </h2>
        <p style={{ marginBottom: '1.5rem', fontSize: '0.9rem', color: '#666' }}>
          Última actualización: {currentDate}
        </p>
        
        <p style={{ marginBottom: '1.5rem' }}>
          <strong>MaipoSalud Centro de Diagnóstico Médico</strong> (en adelante, "La Clínica") valora su privacidad y se compromete a proteger la confidencialidad de su información médica y personal. Esta política describe cómo gestionamos sus datos al utilizar nuestra aplicación móvil de gestión clínica (en adelante, la "Aplicación").
        </p>
        <p style={{ marginBottom: '1.5rem' }}>
          Esta aplicación está diseñada exclusivamente para pacientes de <strong>MaipoSalud Centro de Diagnóstico Médico</strong> y cumple con las normativas de protección de datos de salud vigentes y las políticas de Google Play.
        </p>

        <p style={{ fontWeight: '600', fontSize: '1.1rem', marginTop: '2rem', marginBottom: '1rem' }}>1. Información que recopilamos</p>
        <p style={{ marginBottom: '1rem' }}>
          Para brindar servicios de agendamiento y visualización de exámenes, recopilamos y procesamos los siguientes datos:
        </p>
        
        <p style={{ fontWeight: '600', marginTop: '1.5rem', marginBottom: '0.5rem' }}>A. Información de Registro y Cuenta</p>
        <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
          <li>RUT / DNI / Cédula de Identidad (para vincular con su ficha clínica única).</li>
          <li>Nombre completo, fecha de nacimiento y género.</li>
          <li>Número de teléfono y correo electrónico.</li>
          <li>Contraseña encriptada de acceso.</li>
        </ul>

        <p style={{ fontWeight: '600', marginTop: '1.5rem', marginBottom: '0.5rem' }}>B. Datos Médicos y de Salud (Datos Sensibles)</p>
        <p style={{ marginBottom: '0.5rem' }}>
          La Aplicación actúa como un visualizador seguro de su historial en La Clínica. Accedemos a:
        </p>
        <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
          <li><strong>Resultados de Exámenes:</strong> Informes de laboratorio, imágenes (rayos X, ecografías) y diagnósticos emitidos por nuestros profesionales.</li>
          <li><strong>Historial de Citas:</strong> Fechas pasadas y futuras, especialidades médicas visitadas y nombres de los profesionales tratantes.</li>
          <li><strong>Recetas/Prescripciones:</strong> (Si aplica) Medicamentos recetados asociados a sus consultas.</li>
        </ul>

        <p style={{ fontWeight: '600', marginTop: '1.5rem', marginBottom: '0.5rem' }}>C. Información Técnica</p>
        <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
          <li>Identificadores del dispositivo y registros de fallos (crash logs) para mejorar la estabilidad de la app.</li>
        </ul>

        <p style={{ fontWeight: '600', fontSize: '1.1rem', marginTop: '2rem', marginBottom: '1rem' }}>2. Finalidad del tratamiento de datos</p>
        <p style={{ marginBottom: '1rem' }}>
          Utilizamos sus datos estrictamente para los siguientes fines médicos y administrativos:
        </p>
        <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
          <li><strong>Gestión de Citas:</strong> Permitirle reservar, anular o reprogramar horas médicas.</li>
          <li><strong>Entrega de Resultados:</strong> Permitir la descarga y visualización segura de sus exámenes médicos directamente en su dispositivo.</li>
          <li><strong>Notificaciones:</strong> Enviarle recordatorios de citas próximas o avisos de exámenes listos.</li>
          <li><strong>Verificación de Identidad:</strong> Asegurar que solo el paciente titular acceda a su información clínica confidencial.</li>
        </ul>
        <p style={{ marginBottom: '1rem', fontStyle: 'italic' }}>
          No compartimos, vendemos ni utilizamos sus datos médicos con fines publicitarios.
        </p>

        <p style={{ fontWeight: '600', fontSize: '1.1rem', marginTop: '2rem', marginBottom: '1rem' }}>3. Permisos solicitados en el dispositivo</p>
        <p style={{ marginBottom: '1rem' }}>
          Para funcionar, la app requiere los siguientes permisos:
        </p>
        <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
          <li><strong>ALMACENAMIENTO (Lectura/Escritura):</strong> Necesario para descargar y guardar los archivos PDF de sus exámenes en su teléfono.</li>
          <li><strong>CALENDARIO (Opcional):</strong> Para agregar automáticamente sus citas médicas a su calendario personal.</li>
          <li><strong>NOTIFICACIONES:</strong> Para recibir alertas sobre sus horas médicas y exámenes.</li>
        </ul>

        <p style={{ fontWeight: '600', fontSize: '1.1rem', marginTop: '2rem', marginBottom: '1rem' }}>4. Almacenamiento y Seguridad de la Información</p>
        <p style={{ marginBottom: '1rem' }}>
          Dado que tratamos información médica sensible, aplicamos medidas de seguridad reforzadas:
        </p>
        <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
          <li><strong>Cifrado en tránsito y reposo:</strong> Toda comunicación entre la App y los servidores de La Clínica viaja encriptada (SSL/TLS).</li>
          <li><strong>Autenticación:</strong> El acceso a los exámenes requiere validación de identidad.</li>
          <li><strong>Servidores Seguros:</strong> La información no se aloja en la App permanentemente, sino que se consulta en tiempo real desde nuestros servidores clínicos seguros.</li>
        </ul>

        <p style={{ fontWeight: '600', fontSize: '1.1rem', marginTop: '2rem', marginBottom: '1rem' }}>5. Compartir información con terceros</p>
        <p style={{ marginBottom: '1rem' }}>
          Sus datos médicos no se comparten con terceros externos a la prestación del servicio médico, salvo:
        </p>
        <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
          <li>Obligación legal o judicial.</li>
          <li>Procesadores de pago (si la app permite pagar consultas), quienes solo reciben los datos necesarios para la transacción financiera.</li>
        </ul>

        <p style={{ fontWeight: '600', fontSize: '1.1rem', marginTop: '2rem', marginBottom: '1rem' }}>6. Sus Derechos (Acceso, Rectificación y Cancelación)</p>
        <p style={{ marginBottom: '1rem' }}>
          Como paciente, usted tiene derecho sobre su ficha clínica.
        </p>
        <p style={{ marginBottom: '1rem' }}>
          <strong>Eliminación de cuenta de la App:</strong> Puede solicitar desvincular la App de su ficha clínica desde la opción "Ajustes &gt; Eliminar cuenta de la App" o desde la opción de desactivación temporal disponible en su perfil.
        </p>
        <p style={{ marginBottom: '1rem', fontStyle: 'italic' }}>
          Nota: Esto eliminará su acceso digital, pero su ficha clínica médica legal se mantendrá custodiada en La Clínica según los plazos que exige la ley de salud de Chile.
        </p>

        <p style={{ fontWeight: '600', fontSize: '1.1rem', marginTop: '2rem', marginBottom: '1rem' }}>7. Contacto</p>
        <p style={{ marginBottom: '1rem' }}>
          Para consultas sobre la privacidad de sus datos o problemas con el acceso a sus exámenes:
        </p>
        <ul style={{ marginLeft: '2rem', marginBottom: '1rem', listStyle: 'none' }}>
          <li style={{ marginBottom: '0.5rem' }}><strong>Teléfono de Soporte:</strong> +56 2 2510 4300</li>
          <li style={{ marginBottom: '0.5rem' }}><strong>Sitio Web:</strong> <a href="https://www.maiposalud.cl" target="_blank" rel="noopener noreferrer" style={{ color: '#40a534' }}>www.maiposalud.cl</a></li>
        </ul>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
